<template>
  <div class="turntable">
    <template>
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="基础设置" name="1">
          <div class="tables">
            <el-form ref="form" style="width: 700px">
              <el-form-item label="活动名称">
                <el-input v-model="title"></el-input>
              </el-form-item>
              <el-form-item label="活动时间">
                <!-- <el-date-picker
                  v-model="time_date"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="make_date"
                ></el-date-picker> -->
                <el-date-picker
                  v-model="dateValue[0]"
                  type="date"
                  class="date_picker_box"
                  placeholder="开始日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-time-picker
                  placeholder="时间"
                  v-model="timeValue[0]"
                  class="date_picker_box"
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                ></el-time-picker>
                <span style="margin-right: 8px">至</span>
                <el-date-picker
                  v-model="dateValue[1]"
                  type="date"
                  class="date_picker_box"
                  placeholder="结束日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-time-picker
                  placeholder="时间"
                  v-model="timeValue[1]"
                  class="date_picker_box"
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                ></el-time-picker>
              </el-form-item>
              <el-form-item label="活动说明" style="width: 554px">
                <el-input type="textarea" v-model="intro"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="奖品设置" name="2">
          <div class="products">
            <div class="box" :model="addFrom" v-for="(item, idx) in award_setArr" :key="idx">
              <el-form>
                <el-divider content-position="left">
                  <span>奖项 {{ idx + 1 }}</span>
                  <i class="el-icon-delete" @click="del_award(idx)"></i>
                </el-divider>
                <el-form-item label="奖项名称">
                  <el-input
                    type="text"
                    min="0"
                    :disabled="idx == 0 ? true:false"
                    v-model="item.item_name"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item label="奖项等级">
                  <el-select :disabled="idx == 0 ? true:false" v-model="item.level" placeholder="请选择">
                    <el-option
                      v-for="item in award_arr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="奖项类型">
                  <el-radio-group :disabled="idx == 0 ? true:false" v-model="item.type">
                    <el-radio label="0">积分</el-radio>
                    <el-radio label="1">余额</el-radio>
                    <el-radio label="2">优惠券</el-radio>
                    <el-radio label="3">实物</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item v-if="item.type == '0'" label="积分数量">
                  <el-input
                    type="number"
                    min="0"
                    v-model="item.amount"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>
                <el-form-item v-if="item.type == '2'" label="优惠券">
                  <el-tag v-for="tag in item.coupon" :key="tag.name">
                    {{ tag.title }}
                  </el-tag>
                  <el-select
                    style="margin-left: 20px"
                    v-model="item.coupon_id"
                    multiple
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in sList"
                      :key="item.id"
                      :label="item.title"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="item.type == '1'" label="赠送余额">
                  <el-input
                    type="number"
                    min="0"
                    v-model="item.amount"
                    autocomplete="off"
                  ></el-input>
                </el-form-item>

                <template v-if="item.type == '3'">
                  <el-form-item label="数量">
                    <el-input v-model="item.num" autocomplete="off"></el-input>
                  </el-form-item>
                  <el-form-item label="奖品图片">
                    <el-upload
                      class="avatar-uploader"
                      action
                      :show-file-list="false"
                      :http-request="
                        (count, id) => uploadSectionFile(count, idx)
                      "
                    >
                      <img
                        v-if="item.cover_url"
                        :src="item.cover_url"
                        class="avatar"
                      />
                      <i
                        v-else
                        class="el-icon-plus avatar-uploader-icon"
                        v-loading.fullscreen.lock="fullscreenLoading"
                      ></i>
                    </el-upload>
                  </el-form-item>
                </template>
                <div class="bot-con">
                  <el-form-item label="中奖率">
                    <el-input v-model="item.rate">
                      <template slot="append"> % </template>
                    </el-input>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
          <el-button
            type="primary"
            icon="el-icon-circle-plus-outline"
            @click="addAward"
          >
            继续添加
          </el-button>
        </el-tab-pane>
        <el-tab-pane label="高级设置" name="3">
          <div class="tables">
            <div class="tables">
              <el-form class="my-con">
                <el-form-item label="转盘位置">
                  <el-radio-group v-model="part_type">
                    <el-radio label="0">首页</el-radio>
                    <el-radio label="1">支付后</el-radio>
                    <el-radio label="2">无限制</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item label="使用积分" v-if="part_type == 0">
                  <el-input v-model="used_point" style="width: 200px">
                    <template slot="append"> 分抽奖一次 </template>
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="参与设置"
                  class="can-type"
                  v-if="part_type == 1"
                >
                  <div class="my-money">
                    <span>消费满</span>
                    <el-input v-model="min_money">
                      <template slot="append"> 元(含) </template>
                    </el-input>
                    <span>至</span>
                    <el-input v-model="max_money">
                      <template slot="append"> 元(不含) </template>
                    </el-input>
                    <span>赠送</span>
                    <el-input v-model="enter">
                      <template slot="append"> 次抽奖机会 </template>
                    </el-input>
                  </div>
                </el-form-item>
                <el-form-item label="总抽奖机会" v-if="part_type == 0">
                  <el-radio-group v-model="is_all_chance">
                    <el-radio label="0">不限</el-radio>
                    <el-radio label="1">限制</el-radio> </el-radio-group
                  >每人最多有
                  <el-input
                    :disabled="is_all_chance == 0"
                    v-model="all_chance"
                    style="width: 200px"
                  >
                    <template slot="append"> 次 </template>
                  </el-input>
                </el-form-item>
                <el-form-item label="每人每日有">
                  <el-input v-model="per_chance" style="width: 220px">
                    <template slot="append"> 次抽奖 </template>
                  </el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </template>
    <div class="bottomButton">
      <el-button
        v-if="page_status"
        type="primary"
        icon="el-icon-document-checked"
        @click="addData"
        >修 改</el-button
      >
      <el-button
        v-else
        type="primary"
        icon="el-icon-document-checked"
        @click="addData"
        >保 存</el-button
      >
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { addImage } from "@/api/mall";
import { couponList } from "@/api/coupon";
import { addAwardActivty } from "@/api/active";
import { bigwheelorder, editBigList } from "@/api/drawAward";
import Coupons from "@/components/commodity/selectCommodity";
export default {
  computed: {
    ...mapGetters(["token", "app_id", "merch_id"]),
  },
  data() {
    return {
      title: "", //标题
      // time_date: "",
      timeValue: [],
      dateValue: [],
      start_time: "", //时间
      end_time: "",
      score: "", // 条件
      is_all_chance: "", // 总次数0:不限1：限制
      all_chance: "", // 每人最多次数
      per_chance: "",
      is_text: "1",
      intro: "", //活动说明
      all_rate: "",
      per_limit_num: "",
      is_default: "1", // 状态
      is_target: "", // 抽中多少次中奖
      fullscreenLoading: false,
      imageUrl: "",
      dialogFormVisible: false,
      formLabeltwo: [],
      showSelecter: false,
      sList: [],
      init_time: [], // 默认时间
      enjoy_add: "", // 分享增加
      part_type: "0", // 参与方式
      entry_arr: [], // 渠道
      full_money: "", // 消费满
      used_point: "", // 每n积分抽奖
      oil_type: [], // 参与油品类型
      min_money: "", // 最少消费
      max_money: "", // 最高消费
      enter: "", // 赠送抽奖机会
      award_setArr: [
        // 奖项设置
        {
          level: "谢谢参与", // 奖项等级
          type: "", // 奖项类型
          invite_num: "", // 邀请人数
          consume: "", // 消费满
          rate: "", // 中奖率
          coupon: [], // 优惠券
          amount: "", // 余额
          item_name: "谢谢惠顾",
          num: "", // 实物数量
          cover_url: "", // 实物图片
          award_val: "", // 奖项等级
          cover: "",
        },
      ],
      award_arr: [
        {
          value: "一等奖",
          label: "一等奖",
        },
        {
          value: "二等奖",
          label: "二等奖",
        },
        {
          value: "三等奖",
          label: "三等奖",
        },
        {
          value: "谢谢参与",
          label: "谢谢参与",
        },
      ],

      addFrom: {
        item_name: "",
        type: "",
        level: "",
        cover: "",
        name: "",
        num: "",
        point: "",
        cover_url: "",
        is_pos: "0",
        balance: "",
        coupon_id: String,
      },
      activeName: "1",
      tableData: [],
      value: "",
      isedit: false,
      page_status: false,
    };
  },
  watch: {
    dialogFormVisible(val) {
      if (val) {
        this.addFrom = {
          item_name: "",
          level: "",
          cover: "",
          name: "",
          num: "",
          // sort: "",
          cover_url: "",
          is_pos: "0",
        };
      }
    },
  },
  mounted() {
    this.getCommod();
    if (this.$route.query.id) {
      this.page_status = true;
      this.getDetail(this.$route.query.id);
    }
  },
  methods: {
    addAward() {
      if (this.award_setArr.length > 7)
        return this.$message.error("最多添加8个奖项");
      var obj = {
        level: "", // 奖项等级
        type: "", // 奖项类型
        invite_num: "", // 邀请人数
        consume: "", // 消费满
        rate: "", // 中奖率
        coupon: [], // 优惠券
        amount: "", // 余额
        item_name: "",
        num: "", // 实物数量
        cover_url: "", // 实物图片
        award_val: "", // 奖项等级
        cover: "",
        coupon_id: "",
      };
      this.award_setArr.push(obj);
    },
    del_award(idx) {
      if (idx === 0) return this.$message("奖项至少保留一个");
      this.award_setArr.splice(idx, 1);
    },
    // make_date(val) {
    //   this.start_time = new Date(val[0]).getTime() / 1000;
    //   this.end_time = new Date(val[1]).getTime() / 1000;
    // },
    async getDetail(id) {
      try {
        var data = { token: this.token, app_id: this.app_id, id: id };
        const res = await bigwheelorder(data);
        for (let i in res.data) {
          if (
            Object.prototype.toString.call(res.data[i]) == "[object Number]"
          ) {
            res.data[i] = res.data[i].toString();
          }
        }
        if (res.code == 200) {
          this.title = res.data.title;
          this.part_type = res.data.method;
          // this.start_time = res.data.start_time;
          // this.end_time = res.data.end_time;
          // this.time_date = [
          //   new Date(res.data.start_time),
          //   new Date(res.data.end_time)
          // ];
          this.dateValue[0] = res.data.start_time.split(" ")[0];
          this.timeValue[0] = res.data.start_time.split(" ")[1];
          this.dateValue[1] = res.data.end_time.split(" ")[0];
          this.timeValue[1] = res.data.end_time.split(" ")[1];
          this.is_all_chance = res.data.is_all_chance;
          this.all_chance = res.data.all_chance;
          this.per_chance = res.data.per_chance;
          this.all_rate = res.data.all_rate;
          this.intro = res.data.intro;
          this.entry_arr = res.data.channel_type;
          this.oil_type = res.data.good_type;
          this.min_money = res.data.limit_amount;
          this.max_money = res.data.up_amount;
          this.enter = res.data.add_num;
          for (let y in res.data.Products) {
            let arr = [];
            for (let i in res.data.Products[y].coupon) {
              arr.push(res.data.Products[y].coupon[i].title);
            }
            res.data.Products[y].coupon_id = arr;
            for (let m in res.data.Products[y]) {
              if (
                Object.prototype.toString.call(res.data.Products[y][m]) ==
                "[object Number]"
              ) {
                res.data.Products[y][m] = res.data.Products[y][m].toString();
              }
            }
          }
          this.award_setArr = res.data.Products;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 优惠券 列表
    async getCommod() {
      try {
        var data = { token: this.token, app_id: this.app_id, type: 0 };
        const res = await couponList(data);
        if (res.code == 200) {
          this.sList = res.data.result;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 提交数据
    addData() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        merch_id: "",
        store_id: 0,
        title: this.title,
        method: this.part_type,
        start_time: this.start_time,
        end_time: this.end_time,
        is_all_chance: this.is_all_chance,
        all_chance: this.all_chance,
        per_chance: this.per_chance,
        all_rate: this.all_rate,
        intro: this.intro,
        channel_type: this.entry_arr,
        good_type: this.oil_type,
        limit_amount: this.min_money,
        up_amount: this.max_money,
        add_num: this.enter,
        product: this.award_setArr,
      };
      if (this.dateValue !== null && this.dateValue.length !== 0) {
        if (this.dateValue[0] != null) {
          data.start_time =
            new Date(
              this.timeValue[0]
                ? this.dateValue[0] + " " + this.timeValue[0]
                : this.dateValue[0] + " 00:00:00"
            ).getTime() / 1000;
          data.end_time =
            new Date(
              this.timeValue[1]
                ? this.dateValue[1] + " " + this.timeValue[1]
                : this.dateValue[1] + " 23:59:59"
            ).getTime() / 1000;
        }
      } else {
        this.$message.warning("请准确填好活动时间！！！");
        return;
      }
      var rete_all = 0;
      if (this.page_status) {
        data.product.map((item) => {
          console.log(typeof item.coupon_id);
          // if (item.coupon_id) {
          //   if (item.coupon_id.length > 1) {
          //     item.coupon_id = item.coupon_id.join(",");
          //   } else {
          //     item.coupon_id = item.coupon_id[0];
          //   }
          // }
          rete_all += Number(item.rate);
        });
      } else {
        data.product.map((item) => {
          if (item.coupon_id) {
            if (item.coupon_id.length > 1) {
              item.coupon_id = item.coupon_id.join(",");
            } else {
              item.coupon_id = item.coupon_id[0];
            }
          }
          rete_all += Number(item.rate);
        });
      }
      if (!this.title) return this.$message.error("请输入活动名称!");
      if (data.product.length != 8)
        return this.$message.error("请添加满8个奖项");
      if (rete_all > 100)
        return this.$message.error("转盘中奖率总和不超过 100%");
      if (this.page_status) {
        for (let i = 0; i < data.product.length; i++) {
          delete data.product[i].cover_url;
        }
        setTimeout(() => {
          data.id = this.$route.query.id;
          // data.start_time = new Date(data.start_time).getTime() / 1000;
          // data.end_time = new Date(data.end_time).getTime() / 1000;
          editBigList(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: "success",
              });
              this.$router.push("turntableList");
            } else {
              this.$message.error(res.msg);
            }
          });
        }, 500);
      } else {
        addAwardActivty(data).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: res.msg,
              type: "success",
              onClose: () => this.$router.push("turntableList"),
            });
          } else {
            this.$message.error(res.msg);
          }
        });
      }
    },
    deleteRow(index) {
      this.formLabeltwo.splice(index, 1);
    },
    submit() {
      this.dialogFormVisible = false;
      this.formLabeltwo.push(this.addFrom);
    },
    // 自定义上传文件
    uploadSectionFile(content, idx) {
      this.fullscreenLoading = true;
      let data = new FormData();
      data.append("token", this.token);
      data.append("image", content.file);
      addImage(data).then((res) => {
        this.fullscreenLoading = false;
        this.award_setArr[idx].cover = res.data.id;
        this.award_setArr[idx].cover_url = res.data.url;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.turntable {
  width: 100%;
  padding: 15px 25px;
  height: 100%;
  overflow: auto;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
  .el-input {
    width: 60%;
  }
  .el-icon-delete {
    color: crimson;
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
  }
  .my-money {
    min-width: 80px;
    display: flex;
    height: 50px;
    .el-input {
      width: 200px;
    }
    span {
      min-width: 40px;
      display: block;
      padding-left: 10px;
    }
  }
  .screen {
    display: flex;
    flex-direction: row;
    margin-bottom: 25px;
    .el-button,
    .el-select,
    .el-input {
      margin-right: 10px;
    }
  }
  .tables {
    .headline {
      height: 28px;
      line-height: 28px;
      border-bottom: 1px solid #999;
      font-size: 16px;
      margin-bottom: 15px;
    }
    .marginbtm15 {
      margin-bottom: 15px;
    }
  }
  .products {
    display: flex;
    flex-wrap: wrap;
    .box {
      width: 33%;
      .el-form {
        width: 90%;
        background-color: #fff;
        border: 1px solid #dcdfe6;
        padding: 10px 20px;
        margin-top: 10px;
        margin-bottom: 20px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
          0 0 6px 0 rgba(0, 0, 0, 0.04);
      }
    }
  }
  .hint {
    opacity: 0.7;
    width: 100%;
    height: 120px;
    background: #eb80111f;
    border: 1px solid #eb8011;
    padding: 10px;
    .hintCont {
      padding-left: 30px;
      margin-top: 10px;
    }
  }
  .bottomButton {
    margin-top: 20px;
  }
  .date_picker_box {
    width: 140px;
  }
}
</style>

<style lang="scss">
.turntable {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .my-con {
    background-color: #fff;
    border: 1px solid #dcdfe6;
    padding: 10px 20px;
    margin-top: 10px;
    margin-bottom: 20px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .dialog-footer {
    margin-top: 40px;
  }
}
</style>
